import { Input } from "antd";
import "./Res_Search_Header.scss";
import { FiSearch } from "react-icons/fi";

function Res_Search_Header() {
  return (
    <>
      <div className="inner-res-search">
        <Input
          prefix={<FiSearch />}
          className="inner-res-search-header"
          placeholder="Tìm kiếm sản phẩm, thương hiệu hoặc kiểu dáng..."
        />
      </div>
    </>
  );
}

export default Res_Search_Header;
